import styled from 'react-emotion'
import { Flex } from 'shared/ui'

import themeVars from 'ui_theme/site/globals/site.variables'

export default styled(Flex)`
  align-items: center;
  margin-left: -4px;
  color: ${themeVars.ultraLight};
  & > * {
    margin-right: ${themeVars.small};
    :last-child {
      margin-right: 0px;
    }
  }
`
